import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import * as config from './config';
import { NestedLayoutWidget as mainModule } from './main';
import { init as mainTheme } from './themes/main';

declare var require: any;
require('../sass-main/pdc-widget-layout.sass');

export class NestedLayoutWidget extends WidgetBase {
    public static _name: string = config.name;
    public static group: string = config.group;
    public static moduleName: string = config.moduleName;
    public static icon: string = 'th';
    public static themeModule = mainTheme;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-layout'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = config.themeId;
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(NestedLayoutWidget);
